import SeekerJobs from '@/apps/seeker/jobs/SeekerJobs.vue';
import SeekerJobsOpen from '@/apps/seeker/jobs/SeekerJobsOpen.vue';
import SeekerJobsClosed from '@/apps/seeker/jobs/SeekerJobsClosed.vue';
import { requireSeeker } from '../guards/authGuards';

const jobsRoutes = [
  {
    path: '/seeker/jobs',
    component: SeekerJobs,
    beforeEnter: requireSeeker,
    children: [
      {
        path: 'open',
        name: 'seeker-jobs-open',
        component: SeekerJobsOpen,
        meta: {
          title: 'Open Jobs',
        },
      },
      {
        path: 'closed',
        name: 'seeker-jobs-closed',
        component: SeekerJobsClosed,
        meta: {
          title: 'Closed Jobs',
        },
      },
      {
        path: '',
        redirect: { name: 'seeker-jobs-open' },
      },
    ],
  },
];

export default jobsRoutes;
